export const AGE = "AGE"
export const colorOrange = "#f77d00"